/** Foto hero — file locali in /public/hero (mai stock sbagliati). */
import { resolveMediaUrl } from "./mediaUrl";
import { rewriteUploadToStatic } from "./staticMediaRewrite";
import { isWikipediaMediaUrl, certifiedGalleryUrls } from "./ownMaterial";
import { ISCHIA_HERO_BY_SLUG } from "../data/ischiaComuniHero";
import { PROCIDA_CAPRI_HERO_BY_SLUG } from "../data/procidaCapriHero";
import { COSTIERA_HERO_BY_SLUG } from "../data/costieraAmalfitanaHero";
import { SIXAMICO_MEDIA } from "../data/sixamicoMedia";
import { CROGNALETO_SLUG, stripNeritoMediaFromComuneRecord } from "./crognaletoMedia";
import { mergeAssisiTerritoryGallery } from "./assisiMonuments";
import {
  ASSISI_SACRO_CONVENTO_COVER,
  TORRE_DEL_CERRANO_COVER,
  CASTEL_TROSINO_COVER,
} from "../data/tePilotBorghi";
import {
  LAGA_BOSCHI_SENTIERO,
  LAGA_CASCATA_MORRICANA,
  LAGA_VALLE_CENTO_CASCATE,
  LAGA_FOLTRONE_VETTA,
} from "../data/lagaNatureMedia";

/** Host Emergent e CDN esterni dismessi — non usare come hero. */
export const DEAD_MEDIA_HOSTS = [
  "emergentagent.com",
  "emergent.host",
  "customer-assets.emergent",
  "amico-panel.preview",
  "pexels.com",
];

const BAD_PEXELS_IDS = ["19072073", "1365425", "14367018", "2351649", "45769", "1144176"];
const BAD_UNSPLASH_IDS = ["1568526381923"];

export function isDeadMediaUrl(url) {
  if (!url || typeof url !== "string") return true;
  if (DEAD_MEDIA_HOSTS.some((h) => url.includes(h))) return true;
  if (url.includes("pexels.com")) return true;
  if (BAD_UNSPLASH_IDS.some((id) => url.includes(id))) return true;
  return false;
}

const HERO_BASE = `${process.env.PUBLIC_URL || ""}/hero`;
const IMAGES_BASE = `${process.env.PUBLIC_URL || ""}/images`;

export const GRAN_SASSO_IMG = `${HERO_BASE}/gran-sasso.jpg`;
/** Hero statici in /public/hero — deploy lean include la cartella (non dipendere da /api/uploads). */
export const CAMPO_IMPERATORE_IMG = `${HERO_BASE}/campo-imperatore.png`;
export const CAMPO_IMPERATORE_GALLERY = [
  CAMPO_IMPERATORE_IMG,
  "/api/uploads/campo-imperatore/campo-imperatore-02-altopiano-laghetto.png",
  "/api/uploads/campo-imperatore/campo-imperatore-03-altopiano-monti.png",
  "/api/uploads/campo-imperatore/campo-imperatore-04-strada-altopiano.png",
  "/api/uploads/campo-imperatore/campo-imperatore-05-cavalli.png",
  "/api/uploads/campo-imperatore/campo-imperatore-06-cavalli-puledro.png",
  "/api/uploads/campo-imperatore/campo-imperatore-07-strada-gran-sasso.png",
  "/api/uploads/campo-imperatore/campo-imperatore-08-valle-mandria.png",
  "/api/uploads/campo-imperatore/campo-imperatore-trinita-1971.png",
  "/api/uploads/campo-imperatore/campo-imperatore-funivia-gran-sasso.png",
  "/api/uploads/campo-imperatore/campo-imperatore-osservatorio-inaf.png",
  "/api/uploads/campo-imperatore/campo-imperatore-giardino-botanico-rivera.png",
  "/api/uploads/campo-imperatore/campo-imperatore-rifugio-duca-degli-abruzzi.png",
  "/api/uploads/campo-imperatore/campo-imperatore-albergo.png",
];
export const PIETRACAMELA_IMG = `${HERO_BASE}/pietracamela.jpg`;
/** Scorcio Laga — foto © Carla Di Pietro 2011 (copertina Borghi consigliati / home) */
export const CROGNALETO_IMG = `${HERO_BASE}/crognaleto-borgo-vista-laga.png`;
export const PIETRACAMELA_BOSCO_IMG = `${HERO_BASE}/pietracamela-bosco.jpg`;
export const CROGNALETO_SENARICA_IMG = `${HERO_BASE}/crognaleto-senarica.jpg`;
/** Panoramica crepuscolare — foto fornita */
export const CAMPLI_IMG = `${HERO_BASE}/campli.png`;
/** Panorama collinare — foto attuale del borgo */
export const MOSCIANO_FOTO_PAESAGGIO_IMG = `${HERO_BASE}/mosciano-sant-angelo.jpg`;
/** Illustrazione storica «S. Angelo in Musiano» · 1397 (Tonino Di Matteo / Cacchi) */
export const MOSCIANO_SANT_ANGELO_IMG = `${IMAGES_BASE}/mosciano/sant-angelo-in-musiano-1397.png`;
/** Centro storico — Wikimedia Commons (Foto aerea panoramio) */
export const TORRICELLA_SICURA_IMG = `${HERO_BASE}/torricella-sicura.jpg`;
/** Galleria seed disabilitata: in home comune valgono solo le foto caricate in admin (Mongo). */
export const TORRICELLA_SICURA_GALLERY = [];

export const HERO_FALLBACK_IMG = GRAN_SASSO_IMG;

const ITALIAN_HILL = GRAN_SASSO_IMG;

/** Castelli — cima Monte Camicia (paesaggio, non identità del borgo). */
export const CASTELLI_CAMICIA_IMG = `${HERO_BASE}/castelli.jpg`;
/** Castelli — chiesa di San Donato / borgo ceramico (foto proprietaria). */
export const CASTELLI_BORGO_IMG = `${HERO_BASE}/castelli-borgo.jpg`;
/** Identità Castelli in vetrina e gemellaggi: borgo, non Camicia. */
export const CASTELLI_HERO = CASTELLI_BORGO_IMG;

/** Castel del Monte — panorama del borgo alle falde del Gran Sasso (foto fornita). */
export const CASTEL_DEL_MONTE_IMG = `${HERO_BASE}/castel-del-monte.png`;
export const CASTEL_DEL_MONTE_GALLERY = [
  CASTEL_DEL_MONTE_IMG,
  "/api/uploads/castel-del-monte/comune-castel-del-monte-01-sporti-arco-20180814-125119.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-02-vicolo-valle-20180814-124658.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-03-via-municipio-antico-20180814-124731.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-04-via-colle-della-croce-20180814-124707.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-05-locanda-del-granaio-20180814-124323.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-06-sporto-gatto-20180814-125204.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-07-scalinata-coperta-20180814-124506.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-08-sporto-porta-20180814-124457.png",
  "/api/uploads/castel-del-monte/comune-castel-del-monte-09-scala-interna-20180814-124524.png",
];
/** Paganica — facciata del Santuario della Madonna d'Appari. */
export const PAGANICA_IMG = `${HERO_BASE}/paganica.jpg`;
export const PAGANICA_GALLERY = [
  PAGANICA_IMG,
  "/api/uploads/paganica/santuario-madonna-appari-02-20180814-110345.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-03-20180814-110357.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-04-20180814-110807.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-05-20180814-110838.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-06-20180814-110907.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-07-20180814-110926.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-08-20180814-110931.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-09-20180814-110938.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-10-20180814-110943.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-11-20180814-110948.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-12-20180814-111011.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-13-20180814-111020.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-14-20180814-111039.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-15-20180814-111042.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-16-20180814-111059.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-17-20180814-111120.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-18-20180814-111130.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-19-20180814-111330.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-20-20180814-111448.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-21-20180814-111509.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-22-20180814-111513.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-23-20180814-111516.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-24-20180814-111531.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-25-20180814-111744.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-26-20180814-111818.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-27-20180814-111834.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-28-20180814-111841.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-29-20180814-111859.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-30-20180814-111914.jpg",
  "/api/uploads/paganica/santuario-madonna-appari-31-20180814-111930.jpg",
];

/** Assergi — Santuario di San Giovanni Paolo II a San Pietro della Jenca. */
export const ASSERGI_IMG = `${HERO_BASE}/assergi.jpg`;
export const ASSERGI_GALLERY = [
  ASSERGI_IMG,
  "/hero/assergi-jenca-statua.jpg",
  "/hero/assergi-chiesa-01.jpg",
  "/hero/assergi-chiesa-02.jpg",
  "/hero/assergi-fonte-cerreto.jpg",
  "/hero/assergi-funivia.jpg",
  "/images/assergi/san-pietro-jenca-chiesa.jpg",
  "/images/assergi/san-pietro-jenca-chiesa-lato.jpg",
  "/images/assergi/san-pietro-jenca-interno-altare.jpg",
  "/images/assergi/san-pietro-jenca-fontana.jpg",
  "/images/assergi/san-pietro-jenca-evento-borgo.jpg",
];

export const CALASCIO_IMG = `${HERO_BASE}/calascio.png`;
export const CALASCIO_GALLERY = [
  CALASCIO_IMG,
  "/api/uploads/calascio/santa-maria-della-pieta.png",
  "/api/uploads/calascio/rocca-calascio-escursionista.jpg",
];

export const SANTO_STEFANO_DI_SESSANIO_IMG = `${HERO_BASE}/santo-stefano-di-sessanio.jpg`;
export const SANTO_STEFANO_DI_SESSANIO_GALLERY = [
  SANTO_STEFANO_DI_SESSANIO_IMG,
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-02-p-20180814-155012.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-03-p-20180814-155416.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-04-p-20180814-155515.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-05-p-20180814-155536.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-06-p-20180814-155549.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-07-p-20180814-155558.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-08-p-20180814-160155.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-09-p-20180814-160453.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-10-p-20180814-161424.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-11-p-20180814-161501.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-12-p-20180814-161554.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-13-p-20180814-161632.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-14-p-20180814-162349.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-15-p-20180814-162458.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-16-p-20180814-162509.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-17-p-20180814-162752.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-18-p-20180814-162829.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-19-p-20180814-163001.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-20-p-20180814-163049.jpg",
];

/** Abruzzo generico: costa/adriatico — non Gran Sasso per comuni senza foto dedicata. */
export const ABRUZZO_GENERIC_IMG =
  SIXAMICO_MEDIA.mareAdriatico || SIXAMICO_MEDIA.comuni || ITALIAN_HILL;

/** Fallback per regione — mai Gran Sasso fuori Abruzzo. */

export const REGION_HERO_BY_NAME = {
  Abruzzo: ABRUZZO_GENERIC_IMG,
  Basilicata: SIXAMICO_MEDIA.regionBasilicata,
  Calabria: SIXAMICO_MEDIA.regionCalabria,
  Campania: SIXAMICO_MEDIA.regionCampania,
  "Emilia-Romagna": SIXAMICO_MEDIA.regionEmilia,
  "Friuli-Venezia Giulia": SIXAMICO_MEDIA.regionFriuli,
  Lazio: SIXAMICO_MEDIA.regionLazio,
  Liguria: SIXAMICO_MEDIA.regionLiguria,
  Lombardia: SIXAMICO_MEDIA.regionLombardia,
  Marche: SIXAMICO_MEDIA.regionMarche,
  Molise: SIXAMICO_MEDIA.regionMolise,
  Piemonte: SIXAMICO_MEDIA.regionPiemonte,
  Puglia: SIXAMICO_MEDIA.regionPuglia,
  Sardegna: SIXAMICO_MEDIA.regionSardegna,
  Sicilia: SIXAMICO_MEDIA.regionSicilia,
  Toscana: SIXAMICO_MEDIA.regionToscana,
  "Trentino-Alto Adige": SIXAMICO_MEDIA.regionTrentino,
  "Trentino-Alto Adige/Südtirol": SIXAMICO_MEDIA.regionTrentino,
  Umbria: SIXAMICO_MEDIA.regionUmbria,
  "Valle d'Aosta": SIXAMICO_MEDIA.regionValleAosta,
  "Valle d'Aosta/Vallée d'Aoste": SIXAMICO_MEDIA.regionValleAosta,
  Veneto: SIXAMICO_MEDIA.regionVeneto,
};

const MOUNTAINS_CLOUDS =
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1920&q=85";
/** @deprecated Placeholder generico — sostituito dalle foto ufficiali caricate dai comuni (vedi sotto). */
export const VAL_FINO_PLACEHOLDER_IMG =
  "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=1920&q=80";

/** Hero statici /hero — gli upload admin su prod risultano spesso 404. */
export const CIVITELLA_DEL_TRONTO_IMG = `${HERO_BASE}/civitella-del-tronto.jpg`;
export const CASTIGLIONE_MESSER_RAIMONDO_IMG = `${HERO_BASE}/castiglione-messer-raimondo.jpg`;
export const MONTORIO_AL_VOMANO_IMG = `${HERO_BASE}/montorio-al-vomano.jpg`;
export const CASTIGLIONE_MESSER_RAIMONDO_GALLERY = [
  CASTIGLIONE_MESSER_RAIMONDO_IMG,
  `${HERO_BASE}/castiglione-messer-raimondo-alt.jpg`,
];

export const SLUGS_WITHOUT_CERTIFIED_PHOTO = new Set();

export function hasNoCertifiedPhoto(slug) {
  const s = typeof slug === "string" ? slug.trim().toLowerCase() : "";
  return SLUGS_WITHOUT_CERTIFIED_PHOTO.has(s);
}

export const HERO_BY_SLUG = {
  campli: CAMPLI_IMG,
  crognaleto: CROGNALETO_IMG,
  pietracamela: PIETRACAMELA_IMG,
  /** Frazioni Pietracamela — foto distinte (borgo ≠ Prati di Tivo). */
  intermesoli: PIETRACAMELA_IMG,
  "pietracamela__intermesoli": PIETRACAMELA_IMG,
  "prati-di-tivo": PIETRACAMELA_BOSCO_IMG,
  "pietracamela__prati-di-tivo": PIETRACAMELA_BOSCO_IMG,
  "mosciano-sant-angelo": MOSCIANO_SANT_ANGELO_IMG,
  "castiglione-messer-raimondo": CASTIGLIONE_MESSER_RAIMONDO_IMG,
  "civitella-del-tronto": CIVITELLA_DEL_TRONTO_IMG,
  castelli: CASTELLI_HERO,
  "torricella-sicura": TORRICELLA_SICURA_IMG,
  "montorio-al-vomano": MONTORIO_AL_VOMANO_IMG,
  montorio: MONTORIO_AL_VOMANO_IMG,
  "rocca-santa-maria": "/images/rocca-santa-maria/cascata-morricana-cartello.jpg",
  assergi: ASSERGI_IMG,
  paganica: PAGANICA_IMG,
  "campo-imperatore": CAMPO_IMPERATORE_IMG,
  calascio: CALASCIO_IMG,
  "castel-del-monte": CASTEL_DEL_MONTE_IMG,
  "santo-stefano-di-sessanio": SANTO_STEFANO_DI_SESSANIO_IMG,
  assisi: ASSISI_SACRO_CONVENTO_COVER,
  "assisi-san-francesco": ASSISI_SACRO_CONVENTO_COVER,
  "assisi-storia-origini": ASSISI_SACRO_CONVENTO_COVER,
  "teramo__torre-del-cerrano": TORRE_DEL_CERRANO_COVER,
  "torre-del-cerrano": TORRE_DEL_CERRANO_COVER,
  "ascoli-piceno__castel-trosino": "/images/castel-trosino/castel-trosino-panorama.jpg",
  "castel-trosino": "/images/castel-trosino/castel-trosino-panorama.jpg",
  offida: "/hero/offida.jpg",
  ...ISCHIA_HERO_BY_SLUG,
  ...PROCIDA_CAPRI_HERO_BY_SLUG,
  ...COSTIERA_HERO_BY_SLUG,
};

export const GALLERY_BY_SLUG = {
  campli: [CAMPLI_IMG, LAGA_FOLTRONE_VETTA, LAGA_BOSCHI_SENTIERO],
  "mosciano-sant-angelo": [MOSCIANO_SANT_ANGELO_IMG, MOSCIANO_FOTO_PAESAGGIO_IMG],
  crognaleto: [CROGNALETO_IMG, CROGNALETO_SENARICA_IMG, LAGA_VALLE_CENTO_CASCATE, LAGA_BOSCHI_SENTIERO],
  pietracamela: [PIETRACAMELA_IMG, PIETRACAMELA_BOSCO_IMG],
  "castiglione-messer-raimondo": CASTIGLIONE_MESSER_RAIMONDO_GALLERY,
  "civitella-del-tronto": [CIVITELLA_DEL_TRONTO_IMG],
  "montorio-al-vomano": [
    MONTORIO_AL_VOMANO_IMG,
    "/images/montorio-al-vomano/san-rocco.jpg",
    "/images/montorio-al-vomano/collevecchio.jpg",
  ],
  "rocca-santa-maria": [
    "/images/rocca-santa-maria/cascata-morricana-cartello.jpg",
    "/images/rocca-santa-maria/ceppo-rifugio-piazzale.jpg",
    "/images/rocca-santa-maria/ceppo-faggeta-controluce.jpg",
    "/images/rocca-santa-maria/ceppo-pista-forestale.jpg",
    "/images/rocca-santa-maria/ceppo-sentiero-faggi.jpg",
    "/images/rocca-santa-maria/ceppo-area-picnic.jpg",
  ],
  assergi: ASSERGI_GALLERY,
  paganica: PAGANICA_GALLERY,
  "campo-imperatore": CAMPO_IMPERATORE_GALLERY,
  calascio: CALASCIO_GALLERY,
  "castel-del-monte": CASTEL_DEL_MONTE_GALLERY,
  "santo-stefano-di-sessanio": SANTO_STEFANO_DI_SESSANIO_GALLERY,
  castelli: [CASTELLI_BORGO_IMG, CASTELLI_CAMICIA_IMG],
};

/** Carosello home — una foto diversa per località (rete Abruzzo + mete consigliate). */
export const HOME_HERO_SLIDES = [
  { slug: "assisi", name: "Assisi", img: ASSISI_SACRO_CONVENTO_COVER },
  { slug: "torre-del-cerrano", name: "Torre del Cerrano", img: TORRE_DEL_CERRANO_COVER },
  { slug: "castel-trosino", name: "Castel Trosino", img: CASTEL_TROSINO_COVER },
  { slug: "assergi", name: "Assergi", img: ASSERGI_IMG },
  { slug: "castel-del-monte", name: "Castel del Monte", img: CASTEL_DEL_MONTE_IMG },
  { slug: "campo-imperatore", name: "Campo Imperatore", img: CAMPO_IMPERATORE_IMG },
  { slug: "santo-stefano-di-sessanio", name: "Santo Stefano di Sessanio", img: SANTO_STEFANO_DI_SESSANIO_IMG },
  { slug: "calascio", name: "Calascio", img: CALASCIO_IMG },
  { slug: "paganica", name: "Paganica", img: PAGANICA_IMG },
  { slug: "castelli", name: "Castelli", img: CASTELLI_HERO },
  { slug: "castiglione-messer-raimondo", name: "Castiglione Messer Raimondo", img: CASTIGLIONE_MESSER_RAIMONDO_IMG },
  {
    slug: "civitella-del-tronto",
    name: "Civitella del Tronto",
    img: CIVITELLA_DEL_TRONTO_IMG,
  },
  { slug: "pietracamela", name: "Pietracamela", img: PIETRACAMELA_IMG },
  { slug: "crognaleto", name: "Crognaleto", img: CROGNALETO_IMG },
  { slug: "campli", name: "Campli", img: CAMPLI_IMG },
];

export function heroForSlug(slug, region) {
  const s = typeof slug === "string" ? slug.trim().toLowerCase() : "";
  if (s && HERO_BY_SLUG[s]) return HERO_BY_SLUG[s];
  if (hasNoCertifiedPhoto(s)) return "";
  if (region && REGION_HERO_BY_NAME[region]) return REGION_HERO_BY_NAME[region];
  return SIXAMICO_MEDIA.comuni || ITALIAN_HILL;
}

function isBrokenCampliUpload(url) {
  // Legacy path not valid anymore — skip only known bad prefix patterns if needed.
  return false;
}

function isLiveUploadUrl(url) {
  if (!url || typeof url !== "string") return false;
  const u = resolveMediaUrl(url.trim());
  if (!u || isDeadMediaUrl(u)) return false;
  if (isBrokenCampliUpload(u)) return false;
  return String(u).includes("/api/uploads/");
}

function isLegacySiteMediaUrl(url) {
  if (!url || typeof url !== "string") return false;
  const u = resolveMediaUrl(url.trim());
  return Boolean(u && u.includes("/wp-content/uploads/"));
}

function isGalleryMediaUrl(url) {
  if (!url || typeof url !== "string") return false;
  const u = resolveMediaUrl(url.trim());
  if (!u || isDeadMediaUrl(u) || isWikipediaMediaUrl(u)) return false;
  if (isLegacySiteMediaUrl(u)) return true;
  if (String(u).includes("/hero/") || String(u).includes("/images/") || String(u).includes("/img/")) {
    return true;
  }
  return isLiveUploadUrl(url);
}

function isExcludedAssisiMedia(url) {
  return typeof url === "string" && url.toLowerCase().includes("palazzaccia");
}

function finalizeComuneGallery(slug, urls) {
  if (slug !== "assisi") return urls;
  return mergeAssisiTerritoryGallery(urls);
}

export function galleryForComune(c) {
  if (!c) return [SIXAMICO_MEDIA.comuni || ITALIAN_HILL];
  if (String(c.slug || "").toLowerCase() === CROGNALETO_SLUG) {
    c = stripNeritoMediaFromComuneRecord(c);
  }
  const slug = typeof c.slug === "string" ? c.slug.trim().toLowerCase() : "";
  const skipPreset = slug === "assisi";
  const adminCurated = c.image_source === "admin" || c.media_edited_by_admin === true;
  if (adminCurated && Array.isArray(c.gallery) && c.gallery.length === 0) {
    const heroOnly = [c.image, c.hero_image].find((src) => src && isGalleryMediaUrl(src));
    return finalizeComuneGallery(slug, heroOnly ? [resolveMediaUrl(heroOnly)] : []);
  }
  const raw = [c.image, c.hero_image, ...(Array.isArray(c.gallery) ? c.gallery : [])]
    .filter((src) => typeof src === "string" && src.trim() && !isExcludedAssisiMedia(src));
  const seen = new Set();
  const live = [];
  for (const src of raw) {
    const rewritten = rewriteUploadToStatic(src);
    if (!isGalleryMediaUrl(rewritten)) continue;
    const u = resolveMediaUrl(rewritten);
    if (!u || seen.has(u) || isExcludedAssisiMedia(u)) continue;
    seen.add(u);
    live.push(u);
  }
  const certified = certifiedGalleryUrls(live).filter((u) => !isExcludedAssisiMedia(u));
  if (certified.length) {
    const hasAdminGallery = certified.some((u) => u.includes("/api/uploads/admin/"));
    if (adminCurated || hasAdminGallery) {
      return finalizeComuneGallery(slug, certified);
    }
    const preset = !skipPreset && slug && GALLERY_BY_SLUG[slug];
    if (preset?.length) {
      const merged = [...certified];
      for (const p of preset) {
        const u = resolveMediaUrl(p);
        if (u && !merged.includes(u) && !isExcludedAssisiMedia(u)) merged.push(u);
      }
      return finalizeComuneGallery(slug, merged);
    }
    return finalizeComuneGallery(slug, certified);
  }

  const hero = HERO_BY_SLUG[slug];
  const preset = !skipPreset && slug && GALLERY_BY_SLUG[slug];
  if (preset?.length) {
    return finalizeComuneGallery(
      slug,
      [...new Set([hero, ...preset].filter((u) => u && !isExcludedAssisiMedia(u)))],
    );
  }
  return [heroForSlug(slug || c.slug, c.region) || SIXAMICO_MEDIA.comuni || ITALIAN_HILL];
}
